
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const FinalCTA = () => {
  const navigate = useNavigate();
  
  return (
    <motion.div 
      className="mt-20 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.6 }}
    >
      <div className="bg-background/80 backdrop-blur-sm p-8 rounded-lg max-w-2xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">
          Ready to Make Cooking Fun?
        </h2>
        <p className="text-muted-foreground mb-6">
          Join now and start transforming recipes into exciting learning experiences!
        </p>
        <Button 
          size="lg" 
          onClick={() => navigate("/auth")}
          className="bg-primary hover:bg-primary/90"
        >
          Start Your Journey
        </Button>
      </div>
    </motion.div>
  );
};
